export default {
  nav: {
    main: 'Hauptseite',
    ordersAndInvoices: 'Bestellungen und Rechnungen',
    drafts: 'Entwürfe',
    automation: 'Automatisierung',
    workspace: 'Arbeitsbereich',
    templates: 'Vorlagen',
    delivery: 'Zustellung',
    settings: 'Einstellungen',
    shippingLabels: 'Versandetiketten',
    subscriptions: 'Abonnements',
    support: 'Support',
    developer: 'Entwickler',
    writeReview: 'Bewertung schreiben',
    supportTicket: 'Support-Ticket',
    welcomeTour: 'Willkommenstour',
    administratorConsole: 'Administratorkonsole',
    logout: 'Abmelden',
  },
  dashboard: {
    pageTitle: 'Bestellungen und Rechnungen',
    pageDescription: 'Manage your orders and invoices',
    title: 'Bestellungen und Rechnungen',
    selectedOrders: '{count} ausgewählte Bestellungen',
    completed: '% abgeschlossen',
    processing: 'Verarbeitung, bitte warten...',
    bulkDownload: 'Massendownload',
    upgradeBulkDownload: 'Aktualisieren Sie Ihren Plan für den Massendownload',
    showFilters: 'Filter anzeigen',
    hideFilters: 'Filter ausblenden',
    creatingInvoices: 'Rechnungen werden erstellt, bitte warten...',
    bulkCreateInvoices: 'Rechnungen in Masse erstellen',
    cannotCreateAutopilot: 'Sie können keine Rechnungen manuell erstellen, wenn der Rechnungsmodus auf Autopilot steht.',
    exportInvoices: 'Rechnungen oder Bestellungen exportieren',
    capturePayments: 'Zahlungen manuell erfassen',
    filterOrders: 'Bestellungen filtern',
    error: 'Hoppla, etwas ist schiefgelaufen...',
    close: 'Schließen',
    chooseDate: 'Datum auswählen',
    chooseIssueDate: 'Wählen Sie ein Ausstellungsdatum für die ausgewählten Rechnungen',
    cancel: 'Abbrechen',
    createInvoices: 'Rechnungen erstellen',
    storno: 'Storno',
    bulkOrderCapture: 'Massenbestellungserfassung',
  },
  search: {
    createdBetween: 'Erstellt zw.',
    modifiedBetween: 'Geändert zw.',
    orderNumber: 'Bestell-Nr.',
    invoiceNumber: 'Rechnungs-Nr.',
    refundNumber: 'Erstattungs-Nr.',
    customer: 'Kunde',
    payment: 'Zahlung',
    any: 'Alle',
    authorized: 'Autorisiert',
    pending: 'Ausstehend',
    paid: 'Bezahlt',
    partiallyPaid: 'Teilweise bezahlt',
    refunded: 'Erstattet',
    voided: 'Storniert',
    partiallyRefunded: 'Teilweise erstattet',
    unpaid: 'Unbezahlt',
    fulfillment: 'Versand',
    fulfilled: 'Versendet',
    partial: 'Teilweise',
    unfulfilled: 'Nicht versendet',
    loading: 'Bestellungen werden geladen...',
    search: 'Suchen',
  },
  orderList: {
    noCustomer: 'Kein Kunde',
    downloadOrder: 'Bestellung herunterladen',
    deleteWarning: 'Wichtig! Dies löscht alle Rechnungen und Erstattungen, die nach dem Datum erstellt wurden:',
    includingInvoice: 'einschließlich der ausgewählten Rechnung Nr.',
    pressOk: 'Drücken Sie OK zum Fortfahren oder Abbrechen zum Abbrechen.',
    cannotCreateAutopilot: 'Sie können keine Rechnungen manuell erstellen, wenn der Rechnungsmodus auf Autopilot steht.',
    createInvoice: 'Rechnung für diese Bestellung erstellen',
    create: 'Erstellen',
    addCreditNote: 'Gutschrift hinzufügen',
    createStorno: 'Stornorechnung erstellen',
    refund: 'Erstattung',
    downloadInvoice: 'Diese Rechnung herunterladen',
    download: 'Herunterladen',
    default: 'Standard',
    downloadStorno: 'Diese Storno-/Gutschrift herunterladen',
    fulfillOrder: 'Bestellung versenden',
    orderNum: 'Bestell-Nr.',
    locPrefix: 'Standort-Präfix',
    invoiceNum: 'Rechnungs-Nr.',
    refundNum: 'Erstattungs-Nr.',
    customerCol: 'Kunde',
    orderCreatedDate: 'Bestelldatum',
    orderModifiedDate: 'Änderungsdatum',
    delivered: 'Zugestellt',
    paymentStatus: 'Zahlungsstatus',
    fulfillmentStatus: 'Versandstatus',
    totalOutstanding: 'Offener Gesamtbetrag',
    originalPrice: 'Originalpreis',
    noOrders: 'Ihr Shop hat keine Bestellungen für den ausgewählten Status.',
    cannotCreateNoOrders: 'Sie können keine Rechnungen erstellen, wenn keine Bestellungen vorhanden sind.',
    createOrdersFirst: 'Bitte erstellen Sie mindestens eine Bestellung und versuchen Sie es erneut.',
    createOrders: 'Bestellungen erstellen',
    loadingOrders: 'Laden...',
    paidManual: 'Bezahlt - Manuell',
    paid: 'Bezahlt',
    refunded: 'Erstattet',
    pending: 'Ausstehend',
    partiallyPaid: 'Teilweise bezahlt',
    partiallyRefunded: 'Teilweise erstattet',
    fulfilled: 'Versendet',
    unfulfilled: 'Nicht versendet',
    deliveryPending: 'Ausstehend',
    deliverNow: 'Jetzt liefern',
    deliveryPartial: 'Teilweise',
    notDelivered: 'Nicht geliefert',
    deliverAgain: 'Erneut liefern',
    deliveryDetails: 'Lieferdetails',
    deliveryFailed: 'Lieferung fehlgeschlagen',
    sent: 'Gesendet',
    failed: 'Fehlgeschlagen',
    toLabel: 'An',
    folderLabel: 'Ordner',
    open: 'Offen',
    invoice: 'Rechnung',
    creditNote: 'Gutschrift',
    stornoLabel: 'Storno',
    unknown: 'Unbekannt',
    googleDrive: 'Google Drive',
    clientsTablet: 'Kunden-Tablet',
    shippyPro: 'ShippyPro',
    emailChannel: 'E-Mail',
    ftpChannel: 'FTP',
    revertToDate: 'Auf dieses Datum zurücksetzen',
    add: 'Hinzufügen',
    close: 'Schließen',
  },
  downloadDialog: {
    downloadType: '{type} herunterladen...',
    selectTemplate: 'Wählen Sie eine Vorlage aus der Galerie, um Bestellungen, Rechnungen, Stornorechnungen oder Gutschriften zu exportieren.',
    getMoreTemplates: 'Weitere Vorlagen erhalten',
    createNewTemplate: 'Neue Vorlage erstellen',
    allCreatedBetween: 'Alle erstellten {type} zwischen',
    selectedType: 'Ausgewählte {type}',
    and: 'und',
    status: 'Status',
    any: 'Alle',
    open: 'Offen',
    closed: 'Geschlossen',
    cancelled: 'Storniert',
    paymentStatus: 'Zahlungsstatus',
    fulfillmentStatus: 'Versandstatus',
    fulfilled: 'Versendet',
    partial: 'Teilweise',
    unfulfilled: 'Nicht versendet',
    authorized: 'Autorisiert',
    pending: 'Ausstehend',
    paid: 'Bezahlt',
    partiallyPaid: 'Teilweise bezahlt',
    refunded: 'Erstattet',
    voided: 'Storniert',
    partiallyRefunded: 'Teilweise erstattet',
    unpaid: 'Unbezahlt',
    format: 'Format',
    forLocation: 'Für Standort',
    advancedOptions: 'Erweiterte Optionen',
    exportHSCodes: 'Inventar-HS-Codes exportieren (langsamer)',
    noteChrome: 'Hinweis: Für optimale Downloads wird Chrome empfohlen und ein Adblocker sollte deaktiviert sein.',
    downloadIndividually: 'Einzeln herunterladen',
    downloadGrouped: 'Gruppiert herunterladen',
  },
  templates: {
    pageTitle: 'Vorlagen',
    pageDescription: 'Customize your invoice templates',
    title: 'Vorlagen',
    installTranslated: 'Übersetzte Vorlage installieren',
    installTranslatedDesc: 'Wählen Sie eine andere Sprache, indem Sie auf diese Schaltfläche klicken.',
    createNew: 'Bei Bedarf eine neue Vorlage erstellen',
    createNewDesc: 'Klicken Sie auf diese Schaltfläche, um bei Bedarf eine neue Vorlage zu erstellen.',
    customize: 'Vorlagen anpassen',
    customizeDesc: 'Klicken Sie auf die Standardvorlage, um sie anzupassen. Sie können Logo, Farben und für fortgeschrittene Benutzer den Code dahinter ändern.',
    defaultTemplate: 'Rechnung, Storno und Gutschrift (Standard)',
    logo: 'Logo',
    colorPalette: 'Farbpalette',
    getColorPalettes: 'Farbpaletten erhalten',
    paperSize: 'Papierformat',
    format: 'Format',
    a3: 'A3 (297 x 420 mm)',
    a4: 'A4 (210 x 297 mm)',
    a5: 'A5 (148 x 210 mm)',
    legal: 'Legal (215.9 x 355.6 mm)',
    letter: 'Letter (215.9 x 279.4 mm)',
    tabloid: 'Tabloid (279.4 x 431.8 mm)',
    mcPrint3: 'mC-Print3 Rolle (80 x 155 mm)',
    mcPrint2: 'mC-Print2 Rolle (57.5 x 155 mm)',
    orientation: 'Ausrichtung',
    landscape: 'Querformat',
    portrait: 'Hochformat',
    margin: 'Rand (cm)',
    unsavedChanges: 'Nicht gespeicherte Änderungen',
    discard: 'Verwerfen',
    save: 'Speichern',
  },
  labels: {
    pageTitle: 'Versandetiketten',
    pageDescription: 'Create and manage shipping labels',
    title: 'Versandetiketten',
    glsRequiresPro: 'GLS Versandetiketten für EEU erfordern den Professional-Plan.',
    upgradeDesc: 'Aktualisieren Sie auf Professional, um Versandetiketten zu erstellen und zu verwalten.',
    upgradePlan: 'Plan aktualisieren',
    eeuGls: 'EEU GLS',
    enabled: 'Aktiviert',
    country: 'Land',
    hungary: 'Ungarn',
    slovakia: 'Slowakei',
    czech: 'Tschechien',
    romania: 'Rumänien',
    slovenia: 'Slowenien',
    croatia: 'Kroatien',
    senderId: 'Absender-ID',
    username: 'Benutzername',
    password: 'Passwort',
    name: 'Name',
    city: 'Stadt',
    address: 'Adresse',
    zipCode: 'Postleitzahl',
    contactPerson: 'Kontaktperson',
    phone: 'Telefon',
    email: 'E-Mail',
    glsServices: 'GLS Dienste',
    expressService: 'Express-Dienst',
    exchangeService: 'Tausch-Dienst',
    smsService: 'SMS-Dienst',
    smsText: 'SMS-Text',
    preAdviceService: 'PreAdvice-Dienst',
    unsavedChanges: 'Nicht gespeicherte Änderungen',
    discard: 'Verwerfen',
    save: 'Speichern',
  },
  billing: {
    pageTitle: 'Abrechnung',
    pageDescription: 'Manage your subscription and billing',
    title: 'Abrechnung',
    subscriptionFor: 'Abonnement-Plan für Shop',
    currentlySubscribed: 'Sie haben derzeit ein Abonnement für den',
    plan: 'Plan',
    cancelSubscription: 'Abonnement kündigen',
    upgradePlan: 'Plan aktualisieren',
    professional: 'Professional',
    proPriceMonthly: '$29.99 / Monat',
    upgrade: 'Aktualisieren',
    includesAllStarter: 'Beinhaltet alle Starter-Funktionen, plus:',
    proFeature1: 'Globale Compliance-Suite: Standortbasierte Präfixe und benutzerdefinierte fortlaufende Nummerierung',
    proFeature2: 'Intelligente Lokalisierung: Automatisch übersetzte E-Mails und lokalisierte PDF-Anhänge',
    proFeature3: 'Vollständiger B2B-Dokumentenlebenszyklus: Proformas, B2B-Angebote und Gutschriften',
    proFeature4: 'B2B-Buchhaltungssynchronisierung: 3-Dezimalstellen-Einheitspräzision und Mehrwährungsanzeige',
    proFeature5: 'Automatische Backups: Rechnungen automatisch auf sicheren FTP oder Google Drive kopieren',
    proFeature6: 'Shopify Flow: Rechnungserstellung, Zustellung und Storno über Flow-Trigger und -Aktionen automatisieren',
    proFeature7: 'Erweiterte KI-Logik: On-Device-KI für komplexe bedingte Layout-Klauseln verwenden',
    proFeature8: 'UBL XML & ZUGFeRD / Factur-X Exporte (Europäische E-Rechnungs-Compliance)',
    proFeature9: 'EPC QR-Codes für sofortige mobile POS-Zahlungen',
    proFeature10: 'GLS Versandetiketten für EEU',
    proFeature11: '7 Jahre Compliance-Steueraufbewahrung',
    currentlyUsing: 'Sie nutzen derzeit unseren',
    free: 'kostenlosen',
    subscriptionPlan: 'Abonnement-Plan.',
    monthlyUsage: 'Monatliche Nutzung',
    monthlyGenerated: '{count} / 50 Rechnungen in diesem Monat',
    monthlyLimitReached: 'Monatliches Limit erreicht. Aktualisieren Sie auf Starter für unbegrenzte Rechnungen.',
    freePlan: 'Kostenloser Plan',
    freeToInstall: 'Kostenlos zu installieren',
    freeFeature1: 'Bis zu 50 Rechnungen/Bestellungen pro Monat',
    freeFeature2: 'Zugang zu allen 31+ vordefinierten Vorlagen',
    freeFeature3: 'Basis KI-Copilot',
    freeFeature4: 'Standard-PDF-Downloads & Drucken',
    freeFeature5: 'Standard-Dokumentensuite (Rechnungen, Lieferscheine, Quittungen)',
    freeFeature6: '3 Monate sichere Rechnungsaufbewahrung',
    starterPlan: 'Starter-Plan',
    starterPrice: '$9.99 / Monat',
    starterPricePerInvoice: '+ 3¢ pro erstellter Rechnung',
    subscribe: 'Abonnieren',
    starterFeature1: 'Unbegrenzte Rechnungen & Bestellungen',
    starterFeature2: 'Automatischer PDF-Versand per E-Mail',
    starterFeature3: 'Voller Zugang zum Hybrid-Editor & KI-Copilot',
    starterFeature4: 'Shopify POS & Barcode-Integration',
    starterFeature5: 'Shopify Flow: Trigger & Aktionen für Rechnungsautomatisierung',
    starterFeature6: 'UBL XML / PEPPOL & ZUGFeRD / Factur-X Exporte (E-Rechnungs-Compliance)',
    starterFeature7: '1 Jahr sichere Rechnungsaufbewahrung',
    proTaxOverrides: 'Benutzerdefinierte Steuerüberschreibungen: MwSt. / GST pro Produkt und SKU-basierte Steuersätze',
    unsavedChanges: 'Nicht gespeicherte Änderungen',
    discard: 'Verwerfen',
    save: 'Speichern',
  },
  autopilot: {
    pageTitle: 'Automatisierung',
    pageDescription: 'Automate invoice creation and management',
    title: 'Automatisierung',
    autoCreate: 'Rechnungen automatisch erstellen',
    disabled: 'Deaktiviert (Manuell)',
    whenCreated: 'Wenn Bestellungen erstellt werden',
    whenFulfilled: 'Wenn Bestellungen versendet werden',
    whenPaid: 'Wenn Bestellungen bezahlt werden',
    autoCreateDesc: 'Rechnungen werden am Datum erstellt, an dem Bestellungen erstellt, versendet oder bezahlt werden.',
    autoStorno: 'Rechnungen automatisch stornieren',
    whenCancelled: 'Wenn Bestellungen storniert oder erstattet werden',
    autoStornoDesc: 'Stornorechnungen werden am Datum erstellt, an dem Bestellungen storniert oder Erstattungen erstellt werden.',
    cannotAutoFree: 'Das automatische Erstellen von Rechnungen ist mit dem kostenlosen Plan nicht möglich.',
    upgradePlan: 'Plan aktualisieren',
    unsavedChanges: 'Nicht gespeicherte Änderungen',
    discard: 'Verwerfen',
    save: 'Speichern',
  },
  delivery: {
    pageTitle: 'Zustellung',
    pageDescription: 'Configure invoice delivery via email, FTP, or Google Drive',
    title: 'Zustellung',
    settings: 'Einstellungen',
    useOrderNumbers: 'Bestellnummern für Dateien verwenden',
    sendIfCountry: 'Senden, wenn das Rechnungsadressland ist',
    countryCodesHint: 'Alle Ländercodes durch Semikolon getrennt auflisten.',
    sendForTags: 'Senden für Kunden, die eines der aufgeführten Tags haben',
    tagsHint: 'Alle Tags durch Semikolon getrennt auflisten.',
    emailDelivery: 'E-Mail-Zustellung',
    sendAsPdf: 'Rechnungen als PDF-Anhang an Kunden senden',
    autoSend: 'Automatisch senden, wenn eine Rechnung erstellt wird',
    subject: 'Betreff',
    body: 'Nachrichtentext',
    xmlAttachments: 'XML-Anhänge',
    attachUbl: 'UBL/PEPPOL XML anhängen (E-Factura)',
    attachZugferd: 'ZUGFeRD / Factur-X XML anhängen',
    sendTestEmail: 'Test-E-Mail senden',
    sending: 'Wird gesendet...',
    customSmtp: 'Benutzerdefinierter SMTP-Server',
    customSmtpDesc: 'Verwenden Sie Ihren eigenen Mailserver anstelle des Standardservers',
    enableSmtp: 'Benutzerdefinierten SMTP aktivieren',
    smtpHost: 'SMTP-Host',
    port: 'Port',
    useSsl: 'SSL/TLS verwenden',
    username: 'Benutzername',
    password: 'Passwort',
    fromEmail: 'Absender-E-Mail',
    fromName: 'Absendername',
    shopifyLiquid: 'Shopify Liquid-Vorlage',
    pasteInto: 'Fügen Sie dies in Ihre',
    orderConfirmation: 'Bestellbestätigungsvorlage',
    toAddLink: 'ein, um einen Download-Link hinzuzufügen.',
    downloadInvoice: 'Rechnung herunterladen',
    clientsTablet: 'ClientsTablet',
    clientsTabletDesc: 'Anfragen an ClientsTablet senden, wenn Rechnungen erstellt werden',
    shippyPro: 'ShippyPro',
    shippyProDesc: 'PDF-Rechnungen als Zolldokumente an ShippyPro für Nicht-EU-Länder senden',
    ftpBackup: 'FTP/SFTP-Backup',
    ftpDesc: 'Rechnungen automatisch auf Ihren Server kopieren',
    enableFtp: 'Automatisches FTP-Backup aktivieren',
    host: 'Host',
    useSftp: 'SFTP verwenden (sicher)',
    destinationFolder: 'Zielordner',
    xmlFiles: 'XML-Dateien',
    includeUbl: 'UBL/PEPPOL XML einschließen (E-Factura)',
    includeZugferd: 'ZUGFeRD / Factur-X XML einschließen',
    testConnection: 'Verbindung testen',
    testing: 'Teste...',
    pro: 'PRO',
    upgradeFtp: 'Aktualisieren Sie auf Professional, um Rechnungen automatisch auf Ihren FTP/SFTP-Server zu kopieren.',
    googleDrive: 'Google Drive',
    googleDriveDesc: 'Rechnungen automatisch mit Ihrem Drive synchronisieren',
    connected: 'Verbunden',
    disconnect: 'Trennen',
    notWorking: 'Funktioniert nicht? Gehen Sie zu',
    googlePermissions: 'Google-Berechtigungen',
    removeThenReconnect: 'entfernen Sie Invoice Browse und verbinden Sie erneut.',
    connectGoogleDrive: 'Google Drive verbinden',
    upgradeGoogleDrive: 'Aktualisieren Sie auf Professional, um Rechnungen automatisch mit Google Drive zu synchronisieren.',
    unsavedChanges: 'Nicht gespeicherte Änderungen',
    discard: 'Verwerfen',
    freePlanTitle: 'Automated delivery is not available on the free plan',
    freePlanDesc: 'Upgrade to Starter or Professional to automatically send invoices via email, FTP, or Google Drive.',
    emailLiquidTemplate: 'Email Liquid Template',
    liquidTemplateDesc: 'Copy and paste this code to your order confirmation template. Click {link} to open it.',
    here: 'here',
    save: 'Speichern',
  },
  bookkeeping: {
    pageTitle: 'Einstellungen',
    pageDescription: 'Configure your invoice settings',
    title: 'Einstellungen',
    owner: 'Inhaber',
    email: 'E-Mail',
    phone: 'Telefon',
    keepDifferentNumbering: 'Unterschiedliche Rechnungsnummerierung für jeden Bestellstandort beibehalten',
    keepDifferentNumberingDisabled: 'Unterschiedliche Rechnungsnummerierung für jeden Bestellstandort ist mit Ihrem Plan nicht verfügbar.',
    locationEmailDesc: 'Damit können Sie E-Mails und Rechnungen basierend auf dem Bestellstandort übersetzen: Lagerstandort, Versand- oder Rechnungsadresse',
    upgradePlan: 'Plan aktualisieren',
    matchingCriteria: 'Zuordnungskriterien',
    locationId: 'Standort-ID',
    shippingCountryCode: 'Versandadresse Ländercode',
    billingCountryCode: 'Rechnungsadresse Ländercode',
    matchLocationDesc: 'Standort basierend auf Bestellstandort-ID, Versand- oder Rechnungsadresse Ländercode zuordnen.',
    companyInfo: 'Firmeninformationen',
    name: 'Name',
    website: 'Webseite',
    registrationNumber: 'Registrierungsnummer',
    taxId: 'Steuer-ID',
    addressSection: 'Adresse',
    streetName: 'Straßenname',
    streetNumber: 'Hausnummer',
    zip: 'PLZ',
    city: 'Stadt',
    region: 'Region',
    country: 'Land',
    bankingInfo: 'Bankdaten',
    bankName: 'Bankname',
    swift: 'Swift',
    currency: 'Währung',
    iban: 'IBAN',
    invoicing: 'Rechnungsstellung',
    decimalPlaces: 'Dezimalstellen',
    invoicesPrefix: 'Rechnungspräfix',
    currentInvoiceNumber: 'Aktuelle Rechnungsnummer',
    creditNotesPrefix: 'Gutschriftenpräfix',
    currentCreditNoteNumber: 'Aktuelle Gutschriftennummer',
    lastInvoiceDate: 'Letztes Rechnungsdatum',
    noInvoicesYet: 'Noch keine Rechnungen erstellt.',
    confirmReverting: 'Rücksetzung bestätigen',
    allInvoicesAfter: 'Alle Rechnungen und deren Stornos, die nach dem',
    willBeRemoved: 'ausgestellt wurden, werden entfernt. Mit der Systemrücksetzung fortfahren?',
    cancel: 'Abbrechen',
    revert: 'Zurücksetzen',
    revertDesc: 'Das Zurücksetzen des Systems löscht alle Rechnungen, die nach dem ausgewählten Datum erstellt wurden.',
    revertToDate: 'Auf dieses Datum zurücksetzen',
    reverting: 'System wird zurückgesetzt, bitte warten...',
    useOrderNumbering: 'Bestellnummerierung verwenden',
    showVat: 'MwSt. auf Rechnungen anzeigen',
    overrideTaxes: 'Steuern überschreiben',
    pricesIncludeTax: 'Preise enthalten Steuern',
    productsTaxRate: 'Produkt-Steuersatz',
    shippingTaxRate: 'Versand-Steuersatz',
    skusSeparated: 'SKUs durch Semikolon getrennt',
    skusTaxRate: 'SKU-Steuersatz',
    useOrderDates: 'Bestellerstellungsdaten für Rechnungen verwenden',
    convertCurrency: 'Preise in die Währung umrechnen, in der der Kunde bezahlt',
    unsavedChanges: 'Nicht gespeicherte Änderungen',
    discard: 'Verwerfen',
    save: 'Speichern',
  },
  drafts: {
    pageTitle: 'Entwürfe',
    pageDescription: 'Manage your draft orders',
    title: 'Entwürfe',
    download: 'Herunterladen',
    newDraft: 'Neuer Entwurf',
    exporting: 'Exportiere {status}%...',
    accessNotGranted: 'Zugriff auf Bestellentwürfe nicht gewährt. Bitte',
    reLogin: 'erneut anmelden',
    toGrantPermissions: 'um die erforderlichen "Bestellentwürfe"-Berechtigungen zu erteilen.',
    pushFailed: 'Übertragung an Shopify fehlgeschlagen:',
    exportError: 'Exportfehler:',
    confirmDelete: 'Sind Sie sicher, dass Sie diesen Entwurf löschen möchten?',
    incompleteCustomer: 'Kundendaten sind unvollständig:',
    pushWithoutCustomer: 'Der Entwurf wird ohne Kundendaten an Shopify übertragen. Fortfahren?',
    customerNotInShopify: 'Dieser Kunde existiert noch nicht in Shopify.',
    warnings: 'Warnungen:',
    createCustomerAndPush: 'Kunden in Shopify erstellen und den Bestellentwurf übertragen?',
    downloadTitle: 'Entwürfe herunterladen',
    cancel: 'Abbrechen',
  },
  draftEdit: {
    number: "Nummer",
    prefix: "Präfix",

    newDraft: 'Neuer Entwurf',
    editDraft: 'Entwurf bearbeiten',
    viewInShopify: 'In Shopify anzeigen',
    back: 'Zurück',
    createDraft: 'Entwurf erstellen',
    saveChanges: 'Änderungen speichern',
    documentType: 'Dokumenttyp',
    draftOrder: 'Bestellentwurf',
    quote: 'Angebot',
    proforma: 'Proforma',
    manualInvoice: 'Manuelle Rechnung',
    currency: 'Währung',
    expiryDate: 'Ablaufdatum',
    status: 'Status',
    draft: 'Entwurf',
    sent: 'Gesendet',
    accepted: 'Akzeptiert',
    customer: 'Kunde',
    firstName: 'Vorname',
    lastName: 'Nachname',
    email: 'E-Mail',
    phone: 'Telefon',
    company: 'Firma',
    taxId: 'Steuer-ID',
    billingAddress: 'Rechnungsadresse',
    address: 'Adresse',
    aptSuite: 'Wohnung/Suite',
    city: 'Stadt',
    province: 'Bundesland',
    countryField: 'Land',
    zip: 'PLZ',
    shippingAddress: 'Versandadresse',
    sameAsBilling: 'Gleich wie Rechnungsadresse',
    lineItems: 'Positionen',
    shipping: 'Versand',
    shippingTitle: 'Titel',
    shippingPlaceholder: 'z.B. Standardversand',
    price: 'Preis',
    note: 'Notiz',
    notePlaceholder: 'Interne Notiz oder Nachricht an den Kunden...',
    summary: 'Zusammenfassung',
    subtotal: 'Zwischensumme',
    discounts: 'Rabatte',
    tax: 'Steuer',
    total: 'Gesamt',
  },
  login: {
    pageTitle: 'Invoice Browse - Monthly batch invoicing',
    enterShopAddress: 'Geben Sie Ihre Shop-Adresse ein',
    loginWith: 'Anmelden mit',
    createAccount: 'Neues Konto erstellen',
    placeholder: 'ihr-shop-name',
    shopRequired: 'Shop-Name ist erforderlich',
    login: 'Anmelden',
    shopify: 'Shopify',
    terms: 'Allgemeine Geschäftsbedingungen',
    privacy: 'Datenschutzrichtlinie',
  },
  developer: {
    pageTitle: 'Developer Tools',
    pageDescription: 'Developer tools and API configuration',
  },
  leads: {
    pageTitle: 'Leads',
    pageDescription: 'Manage your leads',
  },
  review: {
    enjoying: 'Gefällt Ihnen Invoice Browse?',
    description: 'Sie haben Ihre ersten Rechnungen erstellt! Wenn Sie die App nützlich finden, hilft uns eine kurze Bewertung im Shopify App Store sehr.',
    reward: 'Als Dankeschön setzen wir Ihren monatlichen Nutzungszähler auf 0 zurück',
    leaveReview: 'Bewertung hinterlassen',
    maybeLater: 'Vielleicht später',
  },
  footer: {
    copyright: '© 2026 Growth Connections',
  },
  joyride: {
    welcomeTitle: 'Willkommen bei Invoice Browse',
    welcomeContent: 'Lassen Sie mich Ihnen zeigen, wie Sie es verwenden können.',
    dashboardTitle: 'Dashboard',
    dashboardContent: 'Der Bildschirm, den Sie sehen, ist das Haupt-Dashboard. Hier finden Sie alle Bestellungen und können sie in verschiedene Dokumenttypen exportieren wie: Rechnungen, Lieferscheine und andere.',
    automationTitle: 'Vereinfachen Sie Ihr Leben',
    automationContent: 'Aktivieren Sie die Automatisierung, um Rechnungen zu erstellen, wenn Bestellungen bezahlt oder erstattet werden.',
    templatesTitle: 'Vorlagen anpassen',
    templatesContent: 'Gehen Sie hier hinein, um Ihre Vorlage zu übersetzen, anzupassen oder eine neue zu erstellen.',
    deliveryTitle: 'Zustellung',
    deliveryContent: 'Konfigurieren Sie unsere App, um erstellte Dokumente automatisch auf FTP, Google Drive oder als E-Mail-Anhänge zu kopieren.',
    settingsTitle: 'Einstellungen',
    settingsContent1: 'Passen Sie Firmentelefonnummer, E-Mail und andere Felder an, die auf Dokumenten verwendet werden.',
    settingsContent2: 'Ändern Sie die Startnummer von Dokumenten oder löschen Sie Dokumente, die nach einem bestimmten Datum erstellt wurden.',
    settingsContent3: 'MwSt.-Sätze für Versand und Produkte überschreiben',
    settingsContent4: 'Dezimalstellen für Zahlen ändern',
    reviewTitle: 'Bewertung schreiben',
    reviewContent: 'Unterstützen Sie unser Team, indem Sie uns eine gute Bewertung schreiben!',
    tourTitle: 'Willkommenstour',
    tourContent: 'Hey, Sie können diese Tour von hier aus erneut öffnen.',
    createDocTitle: 'Erstellen Sie Ihr erstes Dokument',
    createDocContent: 'Klicken Sie auf die Schaltfläche Erstellen, um Ihr erstes Dokument zu erstellen.',
    docNumberTitle: 'Dokumentennummer',
    docNumberContent: 'Das erste Dokument hat die Nummer 1 zugewiesen. Wenn Sie mit einer anderen Nummer beginnen möchten, können Sie dies in den Einstellungen ändern.',
    downloadDocTitle: 'Dokument herunterladen',
    downloadDocContent: 'Klicken Sie auf das Herunterladen-Dropdown und wählen Sie eine Dokumentvorlage, um Ihre Bestellung als PDF zu exportieren.',
  },
  common: {
    save: 'Speichern',
    cancel: 'Abbrechen',
    close: 'Schließen',
    discard: 'Verwerfen',
    delete: 'Löschen',
    edit: 'Bearbeiten',
    create: 'Erstellen',
    loading: 'Laden...',
    unsavedChanges: 'Nicht gespeicherte Änderungen',
    upgradePlan: 'Plan aktualisieren',
  },
  languageSelector: {
    label: 'Sprache',
    auto: 'Automatisch erkennen',
  },
  draftList: {
    draftNum: 'Entwurf #',
    shopifyId: 'Shopify ID',
    type: 'Typ',
    customer: 'Kunde',
    total: 'Gesamt',
    status: 'Status',
    delivered: 'Zugestellt',
    date: 'Datum',
    actions: 'Aktionen',
    noCustomer: 'Kein Kunde',
    noDrafts: 'Keine Entwürfe oder Angebote gefunden.',
    loading: 'Laden...',
    download: 'Herunterladen',
    default: 'Standard',
    pending: 'Ausstehend',
    deliverNow: 'Jetzt zustellen',
    deliveryDetails: 'Zustellungsdetails',
    sent: 'Gesendet',
    failed: 'Fehlgeschlagen',
    deliverAgain: 'Erneut zustellen',
    partial: 'Teilweise',
    notDelivered: 'Nicht zugestellt',
    deliveryFailed: 'Zustellung fehlgeschlagen',
    unknown: 'Unbekannt',
    edit: 'Bearbeiten',
    send: 'Senden',
    pushToShopify: 'An Shopify senden',
    complete: 'Abschließen',
    duplicate: 'Duplizieren',
    delete: 'Löschen',
    quote: 'Angebot',
    proforma: 'Proforma',
    draftOrder: 'Entwurfsbestellung',
    manualInvoice: 'Manuelle Rechnung',
  },
  draftSearch: {
    createdBtw: 'Erstellt zw.',
    draftNum: 'Entwurf #',
    shopifyId: 'Shopify ID',
    customer: 'Kunde',
    status: 'Status',
    type: 'Typ',
    delivery: 'Zustellung',
    any: 'Alle',
    draft: 'Entwurf',
    sent: 'Gesendet',
    accepted: 'Akzeptiert',
    expired: 'Abgelaufen',
    converted: 'Konvertiert',
    cancelled: 'Storniert',
    quote: 'Angebot',
    proforma: 'Proforma',
    draftOrder: 'Entwurfsbestellung',
    manualInvoice: 'Manuelle Rechnung',
    delivered: 'Zugestellt',
    notDelivered: 'Nicht zugestellt',
    pending: 'Ausstehend',
    search: 'Suchen',
  },
  draftDownload: {
    title: 'Entwürfe & Angebote herunterladen...',
    selectTemplate: 'Wählen Sie eine Vorlage aus der Galerie, um Entwürfe, Angebote oder Proforma-Rechnungen zu exportieren.',
    allDraftsBetween: 'Alle Entwürfe zwischen',
    selectedDrafts: 'Ausgewählte Entwürfe',
    and: 'und',
    status: 'Status',
    documentType: 'Dokumenttyp',
    any: 'Alle',
    draft: 'Entwurf',
    sent: 'Gesendet',
    accepted: 'Akzeptiert',
    expired: 'Abgelaufen',
    converted: 'Konvertiert',
    cancelled: 'Storniert',
    quote: 'Angebot',
    proforma: 'Proforma',
    draftOrder: 'Entwurfsbestellung',
    manualInvoice: 'Manuelle Rechnung',
    format: 'Format',
    noTemplates: 'Keine Vorlagen gefunden',
    noTemplatesForType: 'Keine Vorlagen für Dokumenttyp „{type}" gefunden.',
    installTemplates: 'Vorlagen installieren',
    toStartExporting: 'um mit dem Export zu beginnen.',
    noteChrome: 'Hinweis: Für optimalen Download wird Chrome empfohlen und Adblocker sollten deaktiviert sein.',
    cancel: 'Abbrechen',
    downloadIndividually: 'Einzeln herunterladen',
    downloadGrouped: 'Gruppiert herunterladen',
  },
  templateEditor: {
    pageTitle: 'Template Editor',
    pageDescription: 'Edit and customize your invoice template',
    installNewTemplate: 'Neue Vorlage installieren',
    tabStyle: 'Stil',
    tabContent: 'Inhalt',
    tabTranslations: 'Übersetzungen',
    tabSettings: 'Einstellungen',
    tabCode: 'Code',
    tabCopilot: 'KI-Copilot',
    logo: 'Logo',
    colorPalette: 'Farbpalette',
    colorText: 'Text',
    colorBg: 'Hintergrund',
    colorBorder: 'Rand',
    colorPrimary: 'Primär',
    colorAccent: 'Akzent',
    font: 'Schriftart',
    fontDefault: 'Standard (DM Sans)',
    fontSize: 'Schriftgröße',
    fontSizeDefault: 'Standard (11.5px)',
    fontSizeCompact: 'Kompakt',
    fontSizeSmall: 'Klein',
    fontSizeMediumSmall: 'Mittel-Klein',
    fontSizeMedium: 'Mittel',
    fontSizeMediumLarge: 'Mittel-Groß',
    fontSizeLarge: 'Groß',
    fontSizeExtraLarge: 'Extra Groß',
    documentTitle: 'Dokumenttitel',
    documentTitlePlaceholder: 'z.B. Rechnung, Steuerrechnung...',
    noToggleSupport: 'Diese Vorlage unterstützt keine Umschaltsteuerungen. Wechseln Sie zu einer Galerie-Vorlage für volle Anpassung.',
    sections: 'Abschnitte',
    shippingAddress: 'Lieferadresse',
    bankPaymentDetails: 'Bank-/Zahlungsinformationen',
    paymentStatusBadge: 'Zahlungsstatus-Badge',
    orderNotes: 'Bestellnotizen',
    trackingFulfillment: 'Tracking/Versandinformationen',
    termsConditions: 'AGB',
    signatureLines: 'Unterschriftszeilen',
    qrCode: 'QR-Code',
    lineItems: 'Positionen',
    taxColumns: 'Steuerspalten (USt./MwSt.)',
    productSku: 'Produkt-SKU',
    productImages: 'Produktbilder',
    discountBreakdown: 'Rabattaufschlüsselung',
    itemWeight: 'Artikelgewicht',
    hsCode: 'HS-Code (Zoll)',
    mergeDiscounts: 'Rabatte in Produktpreis einrechnen',
    showOrderDiscountAsSummary: 'Rabatt auf Bestellebene als Zusammenfassungszeile anzeigen',
    totals: 'Summen',
    subtotalBeforeTax: 'Zwischensumme (vor Steuer)',
    taxBreakdownByRate: 'Steueraufschlüsselung nach Satz',
    shippingCostSeparate: 'Versandkosten als separate Zeile',
    dueDate: 'Fälligkeitsdatum',
    formatting: 'Formatierung',
    dateFormat: 'Datumsformat',
    decimalPlaces: 'Dezimalstellen',
    paymentTerms: 'Zahlungsbedingungen',
    paymentTermsNone: 'Keine',
    thankYouMessage: 'Dankesnachricht',
    thankYouPlaceholder: 'Vielen Dank für Ihren Einkauf!',
    countryMatchTitle: 'Diese Vorlage verwenden, wenn die Liefer- oder Rechnungsadresse mit diesem Land übereinstimmt',
    addressType: 'Adresstyp',
    addressDisabled: 'Deaktiviert',
    addressShipping: 'Lieferadresse',
    addressBilling: 'Rechnungsadresse',
    country: 'Land',
    anyCountry: 'Beliebiges Land',
    countryMatchDesc: 'Wenn aktiviert, wird diese Vorlage automatisch für Bestellungen verwendet, bei denen die ausgewählte Adresse mit dem gewählten Land übereinstimmt.',
    languagePreset: 'Sprachvoreinstellung',
    selectLanguage: 'Sprache auswählen...',
    languagePresetDesc: 'Die Auswahl einer Sprache füllt alle Beschriftungen unten aus. Sie können dann einzelne Felder anpassen.',
    paperSize: 'Papiergröße',
    format: 'Format',
    orientation: 'Ausrichtung',
    portrait: 'Hochformat',
    landscape: 'Querformat',
    margin: 'Rand (cm)',
    template: 'Vorlage',
    templateName: 'Name',
    systemAlias: 'System-Alias',
    systemAliasDesc: 'für POS/Admin-URL-Routen',
    systemAliasNone: 'Keiner',
    defaultTemplate: 'Standardvorlage',
    defaultTemplateDesc: 'Wird für direkte Links an Kunden verwendet.',
    posRouteDesc: 'Wird auf /template/[alias]/receipt.pdf für POS-Integration abgebildet.',
    documentType: 'Dokumenttyp',
    invoiceCreditNote: 'Rechnung + Gutschrift',
    order: 'Bestellung',
    invoiceOnly: 'Nur Rechnung',
    quoteEstimate: 'Angebot/Kostenvoranschlag',
    proformaInvoice: 'Proforma-Rechnung',
    refund: 'Erstattung',
    stornoInvoice: 'Stornorechnung',
    creditNoteOnly: 'Nur Gutschrift',
    reportLiquid: 'Bericht (nur Liquid)',
    hideRemovedItems: 'Entfernte/erstattete Positionen ausblenden',
    location: 'Standort',
    locationEmpty: 'Leer lassen, um für alle Standorte zu verwenden',
    dangerZone: 'Gefahrenzone',
    dangerZoneDesc: 'Diese Vorlage dauerhaft aus Ihrem Konto entfernen.',
    removeTemplate: 'Vorlage entfernen',
    bodyTemplate: 'Body-Vorlage',
    bodyTemplateDesc: 'Verwendet Mustache- oder Liquid-Syntax. Snippet anklicken:',
    rowTemplate: 'Zeilen-Vorlage',
    rowTemplateDesc: 'Wird einmal pro Position gerendert. Snippet anklicken:',
    variableReference: 'Variablenreferenz',
    formatCode: 'Code formatieren',
    insert: 'Einfügen',
    copy: 'Kopieren',
    loadModelContinue: 'Modell laden & fortfahren',
    cancel: 'Abbrechen',
    copilotPlaceholder: 'Versuchen Sie: ins Deutsche übersetzen, Steuerspalten anzeigen, Barcode hinzufügen...',
    trySamplePrompts: 'Try these sample prompts:',
    undo: 'Rückgängig',
    redo: 'Wiederholen',
    aiThinking: 'KI denkt nach...',
    proposedChanges: 'Vorgeschlagene Änderungen',
    applyChanges: 'Änderungen anwenden',
    dismiss: 'Verwerfen',
    aiEngineReady: 'KI-Engine bereit',
    loadingAiModel: 'KI-Modell wird geladen...',
    aiEngineOff: 'KI-Engine aus —',
    loadForAdvanced: 'für erweiterte Bearbeitung laden',
    instantCommands: 'Übersetzen, Abschnitte ein-/ausblenden, Snippets hinzufügen, Schrift/Farben/Papier ändern',
    aiEngineDesc: 'strukturelle HTML-Bearbeitungen, Layout-Änderungen, benutzerdefinierte Modifikationen',
    aiLocalDesc: 'Modell läuft lokal über WebGPU — keine Daten verlassen Ihren Browser. Größere Modelle sind genauer, benötigen aber mehr VRAM.',
    aiUpgradeDesc: 'Upgrade auf Starter oder Professional für erweiterte KI-Vorlagenbearbeitung.',
    upgrade: 'Upgraden',
    loadAiQuestion: 'KI-Engine laden?',
    loadAiDesc: 'Das On-Device-KI-Modell wird heruntergeladen und lokal über WebGPU ausgeführt. Dies erfordert ~1-3 GB freien VRAM/RAM und eine moderne GPU.',
  },
};



// WEBPACK FOOTER //
// app/intl/locales/de.js